<template>
  <div>
    <v-container id="profile-container">
      <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{ snackbarText }}</v-snackbar>
      <Title title="Profile"></Title>
      <v-row>
        <v-col ld="12">
          <h2>Manage Profile</h2>
          <h4 class="mt-5">
            First Name
            <v-icon
              size="17"
              class="ml-2 mb-1"
              @click.stop="dialog = true; editItem='firstName';"
            >mdi-pencil</v-icon>
          </h4>
          {{firstName}}
          <h4 class="mt-5">
            Middle Name
            <v-icon
              size="17"
              class="ml-2 mb-1"
              @click.stop="dialog = true; editItem='middleName';"
            >mdi-pencil</v-icon>
          </h4>
          {{middleName || '-'}}
          <h4 class="mt-5">
            Last Name
            <v-icon
              size="17"
              class="ml-2 mb-1"
              @click.stop="dialog = true; editItem='lastName';"
            >mdi-pencil</v-icon>
          </h4>
          {{lastName}}
          <h4 class="mt-5">Email</h4>
          {{email}}
          <h4 class="mt-5">Password</h4>
          <a text @click="passwordDialog = true;" style="text-decoration: underline;">Reset Password</a>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="12">
                <v-text-field
                  v-model="editedFirstName"
                  label="First Name"
                  v-if="editItem == 'firstName'"
                ></v-text-field>
                <v-text-field
                  v-model="editedMiddleName"
                  label="Middle Name"
                  v-if="editItem == 'middleName'"
                ></v-text-field>
                <v-text-field
                  v-model="editedLastName"
                  label="Last Name"
                  v-if="editItem == 'lastName'"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile color="blue darken-1" text @click="dialog = false;">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="dialog = false; onEditProfile();">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="passwordDialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Reset Password</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="12">
                <v-form ref="passwordForm">
                  <v-text-field
                    v-model="newPassword"
                    label="New password"
                    :rules="[emptyRule]"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="confirmNewPassword"
                    label="Confirm new password"
                    required
                    :rules="[emptyRule, identicalRule]"
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile color="blue darken-1" text @click="passwordDialog = false;">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onResetPassword();">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Title from "../components/Title";

export default {
  mounted: function () {
    this.getUser();
  },
  components: {
    Title,
  },
  data() {
    return {
      editedFirstName: "",
      editedMiddleName: "",
      editedLastName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      newPassword: "",
      confirmNewPassword: "",
      dialog: false,
      passwordDialog: false,
      editItem: null,
      snackbar: false,
      snackbarText: "",
      emptyRule: (v) => !!v || "This field is required",
      identicalRule: (v) =>
        v == this.newPassword ||
        "Confirm password must be same as new password",
    };
  },
  methods: {
    getUser: function () {
      fetch(
        `${process.env.VUE_APP_ROOT_API}/users/${this.$store.state.userId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // this.isUsersLoading = false;
          this.email = data.user.email;
          this.password = data.user.password;

          const names = data.user.username
            .split(" ")
            .filter((name) => name != "");

          if (names.length == 2) {
            this.firstName = names[0];
            this.lastName = names[1];

            this.editedFirstName = this.firstName;
            this.editedLastName = this.lastName;
          } else if (names.length == 3) {
            this.firstName = names[0];
            this.middleName = names[1];
            this.lastName = names[2];

            this.editedFirstName = this.firstName;
            this.editedMiddleName = this.middleName;
            this.editedLastName = this.lastName;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onEditProfile: function () {
      const data = {
        firstName: this.editedFirstName,
        middleName: this.editedMiddleName,
        lastName: this.editedLastName,
      };

      fetch(
        `${process.env.VUE_APP_ROOT_API}/users/${this.$store.state.userId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then(() => {
          this.snackbarText = "Profile updated";
          this.snackbar = true;
          this.getUser();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onResetPassword: function () {
      if (!this.$refs.passwordForm.validate()) {
        return;
      }

      const data = {
        password: this.newPassword,
      };

      fetch(
        `${process.env.VUE_APP_ROOT_API}/users/${this.$store.state.userId}/password`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then(() => {
          this.snackbarText = "Password updated";
          this.snackbar = true;
          this.getUser();
          this.passwordDialog = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
#profile-container {
  min-height: 100vh;
}
</style>